import { Button } from "react-bootstrap";
import {
  AuthorizationList,
  CanAccess,
} from "../../../components/template/authorization/Authorization";

export const TOPUP_DEPOSIT_TYPE = "topup_deposit";
export const IMMEDIATE_TOPUP_TYPE = "immediate_topup";

export const SEND_TOPUP = "send_topup";
export const SEND_IMMEDIATE_TOPUP = "send_immediate_topup";
export const ACCEPT_DEPOSIT = "accept_deposit";
export const CANCEL_TOPUP_DEPOSIT = "cancel_topup_deposit";
export const REJECT_DEPOSIT = "REJECT_deposit";

const buttonActionStyle = {
  textAlign: "center",
  display: "flex",
  flexDirection: "column",
  gap: "10px",
};

export const requestType = [
  {
    label: "Semua",
    value: 0,
  },
  {
    label: "Top Up Uang Modal",
    value: 1,
  },
  {
    label: "Top Up Uang Kas",
    value: 2,
  },
  {
    label: "Setor",
    value: 3,
  },
];

export const initRequestType = {
  value: 0,
  label: "Semua",
};

export const initTopupDepositFilterInput = {
  outlets: [],
  requestType: 0,
  page: 1,
  pageSize: 10,
  sortingField: null,
  sortingOrder: null,
};

export const initImmediateTopupFilterInput = {
  outlets: [],
  requestStartDate: null,
  requestEndDate: null,
  page: 1,
  pageSize: 10,
  sortingField: null,
  sortingOrder: null,
};

export const renderTopupDepositColumns = (
  handleSendTopupButtonClick,
  handleAcceptDepositButtonClick,
  handleCancelTopupButtonClick
) => {
  return [
    {
      dataIndex: "dateTime",
      key: "dateTime",
      backend_key: "date_time",
      title: "Tanggal & Waktu",
      sorter: true,
      width: "10%",
    },
    {
      dataIndex: "outletName",
      key: "outletName",
      backend_key: "outlet_name",
      title: "Nama Cabang",
      sorter: true,
    },
    {
      dataIndex: "requestType",
      key: "requestType",
      title: "Jenis Permohonan",
    },
    {
      dataIndex: "amount",
      key: "amount",
      title: "Jumlah Top Up / Setor",
    },
    {
      dataIndex: "remainingAmount",
      key: "remainingAmount",
      title: "Sisa Saldo",
    },
    {
      dataIndex: "action",
      key: "action",
      title: "Aksi",
      width: "13%",
      render: (_, record) => (
        <CanAccess
          role={AuthorizationList.update_top_up_deposit}
          yes={
            <div style={buttonActionStyle}>
              {record.state.toLowerCase() === "new" &&
              record.requestType.toLowerCase().includes("top up") ? (
                <Button
                  variant="primary"
                  className="btn-action btn-detail"
                  onClick={() => handleSendTopupButtonClick(record.ID)}
                >
                  Sudah Dikirim
                </Button>
              ) : record.state.toLowerCase() === "new" &&
                record.requestType.toLowerCase().includes("setor") ? (
                <Button
                  variant="primary"
                  className="btn-action btn-detail"
                  onClick={() => handleAcceptDepositButtonClick(record.ID)}
                >
                  Sudah Diterima
                </Button>
              ) : null}

              <Button
                variant="danger"
                className="btn-action btn-delete"
                danger
                onClick={() => handleCancelTopupButtonClick(record.ID)}
              >
                Batalkan
              </Button>
            </div>
          }
        />
      ),
    },
  ];
};

export const renderImmediateTopupColumns = (
  handleSendTopupButtonClick,
  handleCancelTopupButtonClick
) => {
  return [
    {
      dataIndex: "dateTime",
      key: "dateTime",
      backend_key: "date_time",
      title: "Tanggal & Waktu",
      sorter: true,
      width: "10%",
    },
    {
      dataIndex: "outletName",
      key: "outletName",
      backend_key: "outlet_name",
      title: "Nama Cabang",
      sorter: true,
    },
    {
      dataIndex: "officerName",
      key: "officerName",
      backend_key: "officer_name",
      title: "Nama Officer/PoD",
      sorter: true,
    },
    {
      dataIndex: "topupType",
      key: "topupType",
      title: "Jenis Top Up",
    },
    {
      dataIndex: "amount",
      key: "amount",
      title: "Jumlah Top Up",
    },
    {
      dataIndex: "remainingAmount",
      key: "remainingAmount",
      title: "Sisa Saldo",
    },
    {
      dataIndex: "description",
      key: "description",
      title: "Keterangan",
    },
    {
      dataIndex: "action",
      key: "action",
      title: "Aksi",
      render: (_, record) => (
        <CanAccess
          role={AuthorizationList.update_top_up_deposit}
          yes={
            <div style={buttonActionStyle}>
              <Button
                variant="primary"
                className="btn-action btn-detail"
                onClick={() => handleSendTopupButtonClick(record.ID)}
              >
                Sudah Dikirim
              </Button>
              <Button
                variant="danger"
                className="btn-action btn-delete"
                danger
                onClick={() => handleCancelTopupButtonClick(record.ID)}
              >
                Tolak
              </Button>
            </div>
          }
        />
      ),
    },
  ];
};
